"use strict";
// (C) 2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeTime = exports.Timepicker = void 0;
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./typings"), exports);
var Timepicker_1 = require("./Timepicker");
Object.defineProperty(exports, "Timepicker", { enumerable: true, get: function () { return Timepicker_1.Timepicker; } });
Object.defineProperty(exports, "normalizeTime", { enumerable: true, get: function () { return Timepicker_1.normalizeTime; } });
//# sourceMappingURL=index.js.map